<div class="fulfillmentLanding oti-wrapper">
  <div class="commandCenterViewMessage">
    <div>
      <div class="col-12">
        <div class="messageCenterDetail">
          <div class="row m-0 messageHeader">
            <div class="col-10">
              <h3 class="text-left">
                MESSAGE CENTER
              </h3>
            </div>
            <div class="col-2 viewAll text-right">
              <a (click)="backToHome()" class="text-uppercase">Back To Home</a>
            </div>

          </div>

          <div *ngIf="messageCenterMessages?.length" class="messageSection">
            <mat-accordion>
              <mat-expansion-panel (opened)="message.isPanelOpen = true" (closed)="message.isPanelOpen = false"
                                   *ngFor="let message of messageCenterMessages; let i = index" hideToggle="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <div class="padding-l0 mb-0 d-inline-block col-10">
                      <button class="btn btn-link btn-block text-left collapsed" [ngClass]="message.isRead ? '':'unReadMessage'" type="button" (click)="readMessage(message);" data-toggle="collapse" data-target="#messageCenterMessages" aria-expanded="false" aria-controls="messageCenterMessages">

                        <div class="messageDate text-uppercase">
                          {{getFormattedMessageDate(message.updateTimestamp)}}
                        </div>
                        <div class="messageTitle">
                          {{ message.title.length > 120 ? (message.title | slice:0:120) + '...' : message.title }}
                        </div>
                        <div *ngIf="!message.isPanelOpen" class="messageContent">
                          {{ message.message.length > 120 ? (message.message | slice:0:120) + '...' : message.message }}
                        </div>

                        <span></span>
                      </button>
                    </div>
                    <div class="col-2" (click)="$event.stopPropagation();">
                      <div class="row">
                        <span class="col-3 text-center" *ngIf="!message.isPinned" (click)="pinUnPinMessage(message, true)"> <span class="pinUnchecked"></span></span>
                        <span class="col-3 text-center" *ngIf="message.isPinned" (click)="pinUnPinMessage(message, false)"> <span class="pinChecked"></span></span>
                      </div>

                    </div>

                  </mat-panel-title>
                </mat-expansion-panel-header>
                <p [innerHTML]="message.formattedMessage | htmlSanitize" class="mb-0 padding-t15 updateFontFamily" style="font-size:16px;white-space: pre-wrap;  word-wrap: break-word;"></p>
              </mat-expansion-panel>

            </mat-accordion>
          </div>


        </div>
      </div>
    </div>
    <div class="col-12" style="position: fixed; bottom: 5px;">
      <p class="footerNote">If you have any questions or concerns, please reach out to WinField United Customer Service at 855-494-6343 or winfieldcustomerservice&#64;landolakes.com.</p>
    </div>
  </div>
</div>
